import { useMemo } from 'react';

import { buildCareStateGroupedListRows } from '@/entities/care-state-domain';
import type { CareStateDomainDb } from '@/entities/care-state-domain';
import type { ScopedListRow } from '@/features/scoped-tree-viewer';

import { isRequestVisibleInTab, type RequestTabId } from './requestTabs';

export function useCareStateScopeRows(
  careState: CareStateDomainDb | null,
  requestTab: RequestTabId
): ScopedListRow[] {
  return useMemo(() => {
    if (careState === null) return [];

    const filteredRequests = careState.requests.filter((r) =>
      isRequestVisibleInTab(r.status, requestTab)
    );

    // Keep problems even if they have 0 requests in the current tab.
    return buildCareStateGroupedListRows({ ...careState, requests: filteredRequests });
  }, [careState, requestTab]);
}
